import React from 'react'
import TextFieldMui from 'material-ui/TextField'

const TextField = ({ input, meta, label, ...props }) => (
  <TextFieldMui
    value={input.value}
    onChange={input.onChange}
    label={label}
    error={meta.touched && !!meta.error}
    helperText={meta.touched && meta.error}
    InputProps={{
      ...input,
    }}
  />
)
export default TextField



// WEBPACK FOOTER //
// ./src/components/fields/TextField.js